export const Defaults = {
  symbol: "AAPL",
  workspace: "Default",
  cryptoWorkSpace: "Crypto",
};
